import * as React from "react";

export const onderhoudBasePage = (title: string, header: string, message: string) => {
  document.title = title;

  return (
    <div className="content-container">
      <div className="onderhoud-container" data-testid="onderhoud-container">
        <h1>{header}</h1>

        <div className="onderhoud-melding" data-testid="onderhoud-melding">
          {message}
        </div>
      </div>
    </div>
  );
};
